import { Box, Divider, Stack, Typography } from '@mui/material';
import { ASSETS } from '../lib/brand';

/** AST logo lockup for the app header. */
export function BrandLockup() {
  return (
    <Stack direction="row" spacing={1.25} sx={{ alignItems: 'center' }}>
      <Box component="img" src={ASSETS.logo} alt="AST" sx={{ height: 28, width: 'auto', display: 'block' }} />
      <Divider orientation="vertical" flexItem sx={{ my: 0.5 }} />
      <Typography variant="subtitle1" sx={{ color: 'text.secondary', fontWeight: 500 }}>
        Slide
      </Typography>
    </Stack>
  );
}
